import React from 'react';
import RiskProfileRuleTarget from '@/views/components/risk-profiles/RiskProfileRulesTarget';
import { TargetData } from '../types/TargetData';

interface TargetListProps {
  targets: TargetData[];
}

const TargetList: React.FC<TargetListProps> = ({ targets }) => {
  if (!targets.length) {
    return null;
  }

  return (
    <>
      {targets.map(target => (
        <RiskProfileRuleTarget key={target.key} label={target.label} value={target.value} />
      ))}
    </>
  );
};

export default TargetList;
